import YFormShippingDivisions from './ShippingDivisions';

export { YFormShippingDivisions };
export default YFormShippingDivisions;
